import React, { useState } from "react";
import axios from "axios";


const useCheckoutHistory = ({
    onFinish = ({ axiosMode, status, values }) => { },
    onBefore = ({ axiosMode, status }) => { },
}) => {
    const mainApi = '/koha/checkout/history'
    const [data, setData] = useState([])

    const getCheckoutHistoryData = (params) => {
        onBefore({
            axiosMode: "get"
        })
        return axios.get("/library" + mainApi, {
            params: params,
        })
            .then((response) => {
                let data = response.data
                setData(data?.data || [])
                if (data) {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "get",
                            status: "error"
                        }
                    )
                }

                return {
                    ...data
                }
            });
    }
    //新增借書
    const postCheckoutData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(mainApi,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    //續借書
    const postCheckoutRenewData = (data) => {
        onBefore({
            axiosMode: "post"
        })
        axios.post(`/koha/checkout/renew`,
            data
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "success"
                        }
                    )
                }
                else {
                    console.log({message: responseData?.message})
                    onFinish(
                        {
                            axiosMode: "post",
                            status: "error",
                            values: responseData?.message
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "post",
                        status: "error"
                    }
                )
            })

    }
    //刪除借閱紀錄
    const deleteCheckoutHistoryData = (data) => {
        onBefore({
            axiosMode: "delete"
        })
        axios.delete(mainApi,
            {
                data
            }
        )
            .then((response) => {
                let responseData = response.data
                let status = responseData?.status
                if (status === "success") {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "success"
                        }
                    )
                }
                else {
                    onFinish(
                        {
                            axiosMode: "delete",
                            status: "error"
                        }
                    )

                }
            })
            .catch(() => {
                onFinish(
                    {
                        axiosMode: "delete",
                        status: "error"
                    }
                )
            })

    }
    // const patchCheckoutData = (data) => {

    //     onBefore({
    //         axiosMode: "patch"
    //     })
    //     axios.patch(mainApi,

    //             data

    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "patch",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "patch",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    // const deleteCheckoutData = (data) => {
    //     onBefore({
    //         axiosMode: "delete"
    //     })
    //     axios.delete(mainApi,
    //         {
    //             data
    //         }
    //     )
    //         .then((response) => {
    //             let responseData = response.data
    //             let status = responseData?.status
    //             if (status === "fail") {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "error"
    //                     }
    //                 )
    //             }
    //             else {
    //                 onFinish(
    //                     {
    //                         axiosMode: "delete",
    //                         status: "success"
    //                     }
    //                 )
    //             }
    //         })
    //         .catch(() => {
    //             onFinish(
    //                 {
    //                     axiosMode: "delete",
    //                     status: "error"
    //                 }
    //             )
    //         })
    // }
    return {
        CheckoutData: data,
        getCheckoutHistoryData,
        postCheckoutData,
        postCheckoutRenewData,
        deleteCheckoutHistoryData, 
        // patchCheckoutData,
        // deleteCheckoutData,
    }
}
export { useCheckoutHistory }
